<style lang="scss" scoped>

.fade-enter-active, .fade-leave-active {
    transition: all 0.3s ease;
}

.fade-enter-from, .fade-leave-to {
    transform: translateY(-20%);
    opacity: 0;
}

</style>

<template>
    <div class="row mt-3 mb-2">
        <div class="col-12"> 
            <label class="form-label">
                <span v-if="sensorSharedUserList.length === 0">
                    Sensordaten teilen
                </span>
                <span v-else-if="sensorSharedUserList.length === 1">
                    Sensordaten teilen (geteilt mit einem anderen Nutzer)
                </span>
                <span v-else>
                    Sensordaten teilen (geteilt mit {{ sensorSharedUserList.length }} anderen Nutzern)
                </span>
            </label>
            <div class="input-group">
                <select ref="sensorSharedUserId" v-model="sensorSharedUserId" class="form-select">
                    <option :value="null" >
                        <span v-if="sensorSharedUserList.length === 0" class="text-muted">
                            Sensordaten nicht geteilt
                        </span>
                        <span v-else class="text-muted">
                            Nutzer auswählen oder hinzufügen
                        </span>
                    </option>
                    <option v-for="option in sensorSharedUserList" v-bind:key="option.id" v-bind:value="option.id">
                        {{ option.label }}
                    </option>
                </select>
                
                <button v-if="show.addSensorSharedUserId" class="btn btn-info ms-1" @click="showAddSensorSharedUser" title="Nutzer hinzufügen">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon mx-0" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" data-v-4f46756f=""></path>
                        <line x1="12" y1="5" x2="12" y2="19" ></line>
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                    <span class="ms-2">
                        hinzufügen
                    </span>
                </button>
                <button v-if="show.removeSensorSharedUserId" class="btn btn-info ms-1" @click="removeSharedUser" title="Nutzer entfernen">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon mx-0" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <path d="M5 12l14 0" />
                    </svg>
                    <span class="ms-2">
                        entfernen
                    </span>
                </button> 
            </div>  
        </div>           
    </div>
    
    <transition name="fade" @after-enter="$refs.newSensorSharedUserId.focus()" @after-leave="$refs.sensorSharedUserId.focus()">
    <div v-show="show.newSensorSharedUserId" class="row mt-3 mb-2" >
        <div class="col-12">
            <label class="form-label">E-Mail/Benutzername des Nutzers</label>
            <div class="input-group">
                <input ref="newSensorSharedUserId" type="text" v-model="newSensorSharedUserId" class="form-control" name="example-text-input" placeholder="E-Mail Adresse des Nutzer der Bewässerungs-App">
                <button class="btn btn-info ms-1" @click="addSharedUser()">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon mx-0" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" data-v-4f46756f=""></path>
                        <line x1="12" y1="5" x2="12" y2="19" ></line>
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                    <span class="ms-2">
                        Daten teilen
                    </span>
                </button>
                <button class="btn btn-info" @click="hideAddSensorSharedUser">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon mx-0" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <path d="M18 6l-12 12" />
                        <path d="M6 6l12 12" />
                    </svg>                        
                </button>
            </div>
        </div>           
    </div>
    </transition>
    
    <Alert type="danger" :show="alert.sharedUserIdEmpty" :timeout="12000" @after-enter="$refs.newSensorSharedUserId.focus()" >
        <template v-slot:title>E-Mail/Benutzername nicht angegeben</template>
        Die E-Mail bzw. der Benutzername des Nutzers, dem der Sensor mit zur Verfügung gestellt werden soll, fehlt. 
        Bitte geben sie einen korrekten Benutzernamen eines Nutzers der Bewässerungs-App an.
    </Alert>
            
    <Alert type="danger" :show="alert.sharedUserIdNotFound" :timeout="20000" @after-leave="function() {}">
        <template v-slot:title>E-Mail/Benutzername nicht gefunden </template>
        Die von Ihnen angegebene E-Mail bzw. der Benutzername des Nutzers <b>{{ currentUserId }}</b>, dem der Sensor mit zur 
        Verfügung gestellt werden soll, konnte in unserem System nicht gefunden werden. Kontaktieren 
        Sie den Nutzer gegebenfalls direkt, um seine korrekte E-Mail bzw. den Benutzernamen zu erhalten.
    </Alert>
    
    <Alert type="info" :show="alert.sharedUserAdded" :timeout="10000" @after-enter="function() {newSensorSharedUserId = null}">
        <template v-slot:title>Sensor mit Nutzer geteilt</template>
        Der Sensor und dessen Daten werden mit dem Nutzer <b>{{ currentUserId }}</b> geteilt und können von ihm verwendet 
        werden. Der Nutzer wird darüber per E-Mail informiert.
    </Alert>
    
    <Alert type="info" :show="alert.sharedUserAlreadyAdded" :timeout="6000" @after-enter="function() {newSensorSharedUserId = null}">
        <template v-slot:title>Sensor bereits mit Nutzer geteilt</template>
        Der von Ihnen angegebene Nutzer {{ currentUserId }} wurde der Sensor bereits zur Verfügung gestellt.
    </Alert>
    
    <Alert type="info" :show="alert.sharedUserRemoved" :timeout="10000">
        <template v-slot:title>Sensor entzogen</template>
        Der Sensor und dessen Daten können vom Nutzer <b>{{ currentUserId }}</b> nicht verwendet werden. Der Nutzer wird darüber 
        per E-Mail informiert, insofern er die Sensor bereits genutzt hat.
    </Alert>
    
</template>

<script>
import axios from 'axios';
import * as dayjs from 'dayjs';

import Alert from '@/components/Alert.vue';

export default {
    name: 'Share Sensor',
    components: {
        Alert
    },
    inject: [
        'state',
        'config'
    ],
    props: {
        sharedUserIds: {
            type: Array,
            default: function() {
                return [];
            }
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        'sharedUserIds',
        'loading'
    ],
    data: function () {
        return {
            sensorSharedUserId: null,
            newSensorSharedUserId: null,
            currentUserId: null,
            show: {
                addSensorSharedUserId: true,
                removeSensorSharedUserId: false,
                newSensorSharedUserId: false,
            },
            alert: {
                sharedUserIdEmpty: false,
                sharedUserIdNotFound: false,
                sharedUserAdded: false,
                sharedUserAlreadyAdded: false,
                sharedUserRemoved: false
            }
        }
    },
    computed: {
        sensorSharedUserList: function () {
            return this.sharedUserIds.map( function(item) {
                return {
                    id: item,
                    label: item
                }
            })
        }
    },
    methods: {
        validateForm: function () {
           this.alert.emptyProfileName = false;
           this.alert.emptyCropName = false;
           this.alert.emptyProfileYear = false;
           this.alert.areaEmpty = false;
            
           if ( String(this.label).trim() === '' ) {
                this.$nextTick(function() { 
                    this.alert.emptyProfileName = true;
                });
                return false;
           }
            
           return true;
        },
        resetAlerts: function () {
            for (const typ in this.alert) {
                this.alert[typ] = false;
            }
        },
        addSharedUser: function(callback) {
            this.resetAlerts();
            const self = this;
            
            if (!(self.newSensorSharedUserId && self.newSensorSharedUserId.trim() !== '')) {
                self.$nextTick(function() { 
                    self.alert.sharedUserIdEmpty = true;
                });
                return;
            }
            
            let query = {
                query: `
                query (
                    $userId: String!
                ) {
                    users {
                        existUser (userId: $userId) {
                            id
                            label:id
                            existing
                        }   
                    }
                }     
                `,      
                variables: {
                    userId: self.newSensorSharedUserId
                }           
            }
            
            const request = Object.assign({}, self.config.request, {data: query});
            self.$emit('update:loading', true);
            
            
            axios(request).then( function(response) {
                
                response.handler( function(data){
                    if (data.users.existUser.existing === true) {
                        self.addSharedUserToList(data.users.existUser);
                    } else {
                        self.currentUserId = self.newSensorSharedUserId;
                        self.alert.sharedUserIdNotFound = true;
                    }
                });
             
            }).catch(function (error) {
                // console.log(error);
            }).then(function () {
                self.$emit('update:loading', false);
                
                if (callback) {
                    callback(self);
                }
            });
            
        },
        removeSharedUser: function () {
            const self = this;
            
            const sharedUserIds = self.sharedUserIds.filter( function(id) {
                return id !== self.sensorSharedUserId;
            })
            this.$emit('update:sharedUserIds', sharedUserIds);
            
            self.currentUserId = self.sensorSharedUserId;
            self.alert.sharedUserRemoved = true;
            self.sensorSharedUserId = null;
        },
        showAddSensorSharedUser: function () {
            this.newSensorSharedUserId = null;
            this.show.newSensorSharedUserId = true;
            this.resetAlerts();
        },
        hideAddSensorSharedUser: function () {
            this.show.newSensorSharedUserId = false;
            this.resetAlerts();
        },
        addSharedUserToList: function (user) {
            const self = this;
            
            const alreadyShared = self.sharedUserIds.some( function(id) {
                return id === user.id;
            });

            self.currentUserId = user.id;
             
            if (alreadyShared) {
                self.alert.sharedUserAlreadyAdded = true;
                return;
            }
            
            const sharedUserIds = [].concat(self.sharedUserIds, [user.id]);
            this.$emit('update:sharedUserIds', sharedUserIds);
            
            self.alert.sharedUserAdded = true;
            self.sensorSharedUserId = null;
        }
    },
    watch: {
        sensorSharedUserId: function(new_value, old_value) {
            const self = this;
            
            if (new_value) {
                self.show.addSensorSharedUserId = false;
                self.show.removeSensorSharedUserId = true;
            } else {
                self.show.addSensorSharedUserId = true;
                self.show.removeSensorSharedUserId = false;
            }
            
            self.show.newSensorSharedUserId = false;
            this.resetAlerts();
        }
    },
    created: function() {
    },
    mounted: function() {
       
    }
}
</script>

